export function shouldShowMobileMore(visibleRouteCount: number, isStaff: boolean): boolean {
  return !isStaff && visibleRouteCount >= 5;
}

